import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search, CheckCircle2 } from 'lucide-react';
import { useState } from 'react';

interface Supplier {
  supplier_id: string;
  supplier_name: string;
}

interface SupplierSelectorModalProps {
  open: boolean;
  onClose: () => void;
  suppliers: Supplier[];
  onSelectSupplier: (supplierId: string) => void;
}

export function SupplierSelectorModal({
  open,
  onClose,
  suppliers,
  onSelectSupplier
}: SupplierSelectorModalProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredSuppliers = suppliers.filter(s =>
    s.supplier_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.supplier_id.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Select Supplier</DialogTitle>
          <DialogDescription>
            Choose which supplier to use for parsing this bill
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Search */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search suppliers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-9"
            />
          </div>

          {/* Suppliers List */}
          <div className="max-h-[400px] overflow-y-auto space-y-2">
            {filteredSuppliers.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                No suppliers found
              </div>
            ) : (
              filteredSuppliers.map((supplier) => (
                <Button
                  key={supplier.supplier_id}
                  variant="outline"
                  className="w-full justify-start text-left h-auto py-3"
                  onClick={() => onSelectSupplier(supplier.supplier_id)}
                >
                  <div className="flex items-center gap-3 w-full">
                    <CheckCircle2 className="h-5 w-5 text-success flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium truncate">{supplier.supplier_name}</div>
                      <div className="text-xs text-muted-foreground truncate">
                        {supplier.supplier_id}
                      </div>
                    </div>
                    <Badge variant="outline" className="flex-shrink-0">
                      Select
                    </Badge>
                  </div>
                </Button>
              ))
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
